module.exports = __webpack_public_path__ + "static/img/22优秘.0ebd023.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/22优秘.jpg
// module id = yF8V
// module chunks = 1